import React from 'react';
import { Container, Row, Col, CardImg } from 'reactstrap';

const Training = (props) => {
  return (
    <div className="py-5 my-5 text-center">
      <Container className='p-sm-5' style={{ borderRadius: '4px', border: 'solid 4px rgba(255, 255, 255, 0.7)' }}>
          <Row className='justify-content-center'>
            <Col>
              <h1 style={{textAlign: "center"}}>Cybersecurity Certified Training</h1>
              <p>Learn foundational knowledge in cybersecurity and become a certified specialist.</p>
              <hr style={{ backgroundColor: '#FFBD00' }} />
            </Col>
          </Row>
          <Row>
            <Col>
              <h3 className="text-left yellow mt-4">Overview</h3>
            </Col>
          </Row>
          <Row>
            <Col className="text-left py-2">
              <div className='p-2' style={{ backgroundColor: 'rgba(71, 70, 76, 0.8)', borderRadius: '4px' }}>
                <ul className="mt-4" style={{ listStyleType: 'square', color: '#FFBD00' }}>
                  <li><p>Introduction to Security</p></li>
                  <li><p>Network Security</p></li>
                  <li><p>Information Security</p></li>
                  <li><p>Information Systems Security</p></li>
                  <li><p>Security on Cloud-Based Systems</p></li>
                </ul>
              </div>
              
            </Col>
            <Col className="text-left py-2">
              <div className='p-2' style={{ backgroundColor: 'rgba(71, 70, 76, 0.8)', borderRadius: '4px' }}>
                <ul className="mt-4" style={{ listStyleType: 'square', color: '#FFBD00' }}>
                  <li><p>Digital Forensics</p></li>
                  <li><p>Cryptography</p></li>
                  <li><p>Detecting Threats and Penetration</p></li>
                  <li><p>Risk Analytics and Risk Management</p></li>
                  <li><p>and more...</p></li>
                </ul>
              </div>
              
            </Col>
          </Row>
      </Container>
    </div>
  )
}

export default Training;
